module.exports = __webpack_public_path__ + "static/media/logo-icon.6580a2e5.svg";